"use client";

import React from "react";
export default class GoogleAdSenseDisplayAd extends React.Component {
  componentDidMount() {
    if (typeof window !== "undefined") {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
  }

  render() {
    let adTest =
      process.env.ORION_ENV != "production" ? { "data-adtest": "on" } : {};

    return (
      <>
        <ins
          className="adsbygoogle"
          data-ad-client="ca-pub-8178679793640375"
          data-ad-slot="8621499311"
          {...adTest}
        />
        <style jsx>{`
          .adsbygoogle {
            display: inline-block;
            width: 90%;
            max-width: 768px;
            height: 90px;
            margin: 0 auto;
          }
        `}</style>
      </>
    );
  }
}
